<template>
  <div>
    <SysDialog
      v-model="dialog"
      :largura="800"
      titulo="Estoque de segurança por segmento"
      @click:primary="salvarEsseg()"
      @click:hidden-dialog="$emit('fechar-dialog-familia-produto', false)"
    >
      <SysDataTable
        :headers="headers"
        :items="desserts"
        :height="alturaDaJanela - 350"
        :item-height="40"
        :search="search"
        hide-default-footer
      >
        <template #item.tempo_cobertura_esseg="{ item }">
          <TextFieldFormatadorDeValor
            v-model="item.tempo_cobertura_esseg"
            dense
            hide-details
            suffix="dias"
            class="input-cobertura-estoque-seguranca text-field-centralizado my-1"
            @focus="$event.target.select()"
            @keyup.enter="salvarEsseg()"
          />
        </template>
      </SysDataTable>
    </SysDialog>
  </div>
</template>

<script>
import Responsividade from "@/helpers/ResponsiveHeight";
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import SysDataTable from '@/components/utils/dataTable/sysDataTable/Index.vue';
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor.vue";
import { buscarFamiliaProdutoFornecedor, salvarEssegFamiliaProdutoFornecedor } from "./RequisicoesAPI";

export default {
  name: "FamiliaProduto",
  mixins: [Responsividade],
  components: { SysDialog, SysDataTable, TextFieldFormatadorDeValor },
  props: {
    fornecedor: {
      type: Object,
      required: true
    },
    cobertura_selecionada: {
      type: Number
    }
  },
  data: () => ({
    dialog: false,
    headers: [
      { text: 'ID Segmento', value: 'idfamilia_produto' },
      { text: 'Descricao Segmento', value: 'descricao_familia_produto' },
      { text: 'Cobertura', value: 'tempo_cobertura_esseg', style: {width: '100px'} },
    ],
    desserts: [],
    search: ''
  }),
  watch: {
    cobertura_selecionada(valor) {
      const validador = valor === 2;
      this.dialog = validador;
      if (validador) {
        const parametros = {
          id_fornecedor: this.fornecedor.id,
          ativar_grupo_economico_compra: this.fornecedor.grupo_analise_fornecedores ? 'S' : 'N'
        }

        this.$store.dispatch(
          "loading/addRequisicao",
          buscarFamiliaProdutoFornecedor(parametros).then(dado => this.desserts = dado)
        );
      }
    }
  },
  methods: {
    salvarEsseg() {
      const params = {
        id_grupo: this.$store.getters['usuario/getGrupoCompras'],
        id_fornecedor: this.fornecedor.id,
        tipo_esseg: this.cobertura_selecionada,
        valor_esseg: this.cobertura_esseg,
        familia_produto: this.desserts,
        ativar_grupo_economico_compra: this.fornecedor.grupo_analise_fornecedores ? 'S' : 'N'
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        salvarEssegFamiliaProdutoFornecedor(params)
          .then(() => {
            this.dialog = false;
            this.$emit('fechar-dialog-familia-produto', true);
          })
          .catch(() => this.Helpers.logout())
      )
    }
  }
}
</script>

<style>

</style>
